import { ChangeEvent, FC, FormEvent, useState } from 'react';
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@chakra-ui/react';
import { isEmpty, isNil } from 'ramda';

import { validNameRegex } from '../../lib/storage-object/storage-object';

type Props = {
  onCancel: () => void;
  onConfirm: (value: string) => void;
};

export const FolderNameDialog: FC<Props> = ({ onCancel, onConfirm }) => {
  const [folderName, setFolderName] = useState<string>();
  const [validationError, setValidationError] = useState<boolean>(false);

  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    const folderNameInput = target.value;

    if (!folderNameInput.match(validNameRegex)) {
      return setValidationError(true);
    }

    setFolderName(folderNameInput);
    setValidationError(false);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (folderName) {
      onConfirm(folderName);
    }
  };

  const isInvalid = isNil(folderName) || isEmpty(folderName) || validationError;

  return (
    <ModalContent data-testid="create-folder-dialog">
      <ModalHeader fontSize="lg" fontWeight="bold">
        Create Folder
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <FormControl isInvalid={validationError}>
            <FormLabel htmlFor="folderName">
              Please enter the folder name
            </FormLabel>
            <Input
              size="sm"
              type="text"
              id="folderName"
              maxLength={255}
              onChange={handleChange}
              placeholder="Folder Name"
              data-testid="folder-name-input"
            />
            {validationError && (
              <FormErrorMessage data-testid="validation-error">{`Folder names cannot contain invalid characters: \\ ^ / ? * " > < : | %`}</FormErrorMessage>
            )}
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onCancel} data-testid="cancel">
            Cancel
          </Button>
          <Button
            ml={3}
            colorScheme="green"
            disabled={isInvalid}
            data-testid="confirm"
            type="submit"
          >
            Create
          </Button>
        </ModalFooter>
      </form>
    </ModalContent>
  );
};
